


















import {Component} from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Breadcrumb from '@/models/Breadcrumb';
import CountComponent from '@/components/pages/home/CountComponent.vue';
import CountSpeciesComponent from '@/components/pages/home/CountSpeciesComponent.vue';
import CountEntitiesComponent from '@/components/pages/home/CountEntitiesComponent.vue';
import ChartComponent from '@/components/pages/home/ChartComponent.vue';
import BasePageView from '@/views/BasePageView.vue';

@Component({
  components: {
    CountComponent,
    CountSpeciesComponent,
    CountEntitiesComponent,
    ChartComponent,
    BaseLayout,
  }
})
export default class HomeView extends BasePageView{
  breadcrumbs: Breadcrumb[] =  [
    {
      text: 'Accueil',
      disabled: false,
      icon: '',
      href: '/',
    },
    {
      text: 'Tableau de bord',
      disabled: true,
      icon: '',
      href: '/',
    },
  ];
}
